import React from 'react';
import { daMinutiAOre } from './turniHelper';
import { Button } from "react-bootstrap";
import { downloadCsv } from '../utilities/NetUtilities';

function TabellaLavoratore({ tabellaLavoratore, totMinutiLavoratore, urlCsv }) {

    const printRigheSedi = (
        tabellaSedi,
        lavoratore,
        servizio,
        indexLavoratore,
        indexServizio,
        nRighe,
        nRigheServizio,
        rowClass) => {
        if (Object.keys(tabellaSedi).length === 0) {
            return <tr
                className={rowClass}
                id={indexLavoratore - indexServizio}
                key={`row-${indexLavoratore}-${indexServizio}`}>
                {indexServizio === 0 && <td
                    className="cellaSpaziosa inEvidenza bordiSpessi"
                    id={'lavoratore-' + indexLavoratore + '-' + indexServizio}
                    rowSpan={nRighe + 1}>{lavoratore}</td>}
                <td
                    className='cellaSpaziosa bordiSpessi'
                    rowSpan={nRigheServizio}
                    id={'servizio-' + indexLavoratore + '-' + indexServizio}>{servizio}</td>
                <td className='bordiSpessi'></td>
                <td className="center cellaSpaziosa bordiSpessi">{daMinutiAOre(0)}</td>
            </tr>
        } else {
            return Object.keys(tabellaSedi).map((sede, indexSede) => {
                const minuti = tabellaSedi[sede];
                return <tr
                    className={rowClass}
                    id={indexLavoratore - indexServizio - indexSede}
                    key={`row-${indexLavoratore}-${indexServizio}-${indexSede}`}>
                    {indexServizio === 0 && indexSede === 0 && <td
                        className="inEvidenza bordiSpessi"
                        rowSpan={nRighe + 1}
                        id={'lavoratore-' + indexLavoratore + '-' + indexServizio}>{lavoratore}</td>}
                    {indexSede === 0 && <td
                        className='bordiSpessi'
                        rowSpan={nRigheServizio}
                        id={'servizio-' + indexLavoratore + '-' + indexServizio} >{servizio}</td>}
                    <td className='cellaSpaziosa bordiSpessi'
                        id={'sede-' + indexLavoratore + '-' + indexServizio}>{sede}</td>
                    <td className="center cellaSpaziosa bordiSpessi"
                        id={'ore-lavoratore-' + indexLavoratore + '-' + indexServizio + '-' + indexSede}
                    >{daMinutiAOre(minuti)}</td>
                </tr>
            })
        }
    }

    const printRighe = (tabellaServizi, lavoratore, indexLavoratore, nRighe, rowClass) => {
        return Object.keys(tabellaServizi).map((servizio, indexServizio) => {
            var tabellaSedi = tabellaServizi[servizio]
            var nRigheServizio = Math.max(1, Object.keys(tabellaSedi).length);
            return printRigheSedi(
                tabellaSedi, lavoratore, servizio, indexLavoratore, indexServizio, nRighe, nRigheServizio, rowClass)
        })
    }

    const countRighe = (tabellaServizi) => {
        return Object.keys(tabellaServizi).reduce((accumulator, servizio) => (
            accumulator + Math.max(1, Object.keys(tabellaServizi[servizio]).length)
        ), 0);
    }

    const printTabella = () => {
        return (
            Object.keys(tabellaLavoratore).map((lavoratore, indexLavoratore) => {
                const rowClass = indexLavoratore % 2 === 0 ? 'lineaGrigia' : 'lineaBianca';
                var tabellaServizi = tabellaLavoratore[lavoratore];
                var minutiTot = totMinutiLavoratore[lavoratore];
                if (Object.keys(tabellaServizi).length === 0) {
                    return (
                        <tr key={`table-${indexLavoratore}`} className={rowClass}>
                            <td className="cellaSpaziosa inEvidenza bordiSpessi" id={'lavoratore-' + indexLavoratore + '-0'}>{lavoratore}</td>
                            <td className="bordiSpessi"></td>
                            <td className="inEvidenza right cellaSpaziosa bordiSpessi">totale ore</td>
                            <td className="inEvidenza center cellaSpaziosa bordiSpessi" id={'totorelavoratore-' + indexLavoratore}>{daMinutiAOre(minutiTot)}</td>
                        </tr>
                    );
                }
                var nRighe = countRighe(tabellaServizi);
                return (
                    <React.Fragment key={`table-${indexLavoratore}`}>
                        {printRighe(tabellaServizi, lavoratore, indexLavoratore, nRighe, rowClass)}
                        <tr key={`total-${indexLavoratore}`}>
                            <td className={`bordiSpessi ${rowClass}`}></td>
                            <td className={`inEvidenza right cellaSpaziosa bordiSpessi ${rowClass}`}>totale ore</td>
                            <td className={`inEvidenza center cellaSpaziosa bordiSpessi ${rowClass}`} id={'totorelavoratore-' + indexLavoratore}>{daMinutiAOre(minutiTot)}</td>
                        </tr>
                    </React.Fragment>
                );
            })
        );
    }

    return <div id="tabella-lavoratore" className='table-responsive'>
        <h2 className='inEvidenza'>Totale lavoratore <Button
            data-toggle="tooltip"
            title="Download CSV"
            className='btnGenerale'
            variant="flat"
            size="sm"
            id="csv-lavoratore"
            onClick={() => { downloadCsv(urlCsv, "totale-lavoratore.csv") }}
        >scarica</Button></h2>
        {tabellaLavoratore && <table id="tabella-lavoratore" className="table-bordered bottom-space">
            <thead className="App">
                <tr>
                    <th className="inEvidenza cellaSpaziosa bordiSpessi">lavoratore</th>
                    <th className="inEvidenza cellaSpaziosa bordiSpessi">servizio</th>
                    <th className="inEvidenza cellaSpaziosa bordiSpessi">sede</th>
                    <th className="inEvidenza cellaSpaziosa bordiSpessi">totale (hh:mm)</th>
                </tr>
            </thead>
            <tbody>
                {printTabella()}
            </tbody>
        </table>}
    </div>
}

export default TabellaLavoratore;